import useCanvas from '@canvas-builder/composables/useCanvas'
import type { UiSelectCollectionPlayerRequest, UiSelectCollectionPlayerResponse } from '@sdk/api/modules/ui/types.ui'
import type { CollectionPlayer } from '@collection-player/types/collection-player.type'
import { getGroupsCount, getSlidesCount, getUniqueFilesCount } from '@collection-selector/utils/data.util'

export default (
  selectCollectionPlayerContent?: (
    payload?: UiSelectCollectionPlayerRequest,
  ) => Promise<UiSelectCollectionPlayerResponse>,
) => {
  const { updateNodeDataById, setComponentSettingsMode, contentRef, onCollectionPlayerContentChange } = useCanvas()

  const trackContentChange = (id: string, data: CollectionPlayer) => {
    const uniqueFilesCount = data ? getUniqueFilesCount(data) : 0
    const groupsCount = data ? getGroupsCount(data) : 0
    const slidesCount = data ? getSlidesCount(data) : 0

    onCollectionPlayerContentChange.value?.({
      componentId: id,
      uniqueFilesCount,
      groupsCount,
      slidesCount,
    })
  }

  const selectContent = async ({ id, initialData }: { id: string; initialData: CollectionPlayer }) => {
    if (!selectCollectionPlayerContent) {
      console.error('selectCollectionPlayerContent is not provided')
      return
    }

    const response = await selectCollectionPlayerContent({
      initial_data: initialData,
      open_settings: () => setComponentSettingsMode(id),
      attach_to: contentRef.value?.$el ?? undefined,
    })

    if (response.content) {
      updateNodeDataById(id, response.content)
      trackContentChange(id, response.content)
    }
  }

  return {
    selectContent,
  }
}
